module.exports = __webpack_public_path__ + "img/img1.b42bb7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1.png
// module id = fgq6
// module chunks = 2